import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

/**
 * Returns the ISO currency code configured for an organization.
 * Defaults to 'COP' when organizationId is null/undefined/'all' or the org has no value set.
 */
export function useOrgCurrency(organizationId?: string | null) {
  const enabled = !!organizationId && organizationId !== 'all';

  const { data } = useQuery({
    queryKey: ['org-currency', organizationId],
    enabled,
    staleTime: 1000 * 60 * 30,
    queryFn: async () => {
      const { data, error } = await supabase
        .from('organizations')
        .select('currency')
        .eq('id', organizationId as string)
        .maybeSingle();
      if (error) throw error;
      return (data?.currency as string) || 'COP';
    },
  });

  return enabled ? (data || 'COP') : 'COP';
}
